var _defs, _circle, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconArrowRightWhiteCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0067df;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18-UIP-0004_BrandCtr_Nav_Icon_ArrowRightWhite_CircleBlue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 11.99998
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    className: "cls-2",
    points: "19 26.59 23.945 22 19 17.41 20.522 16 27 22 20.522 28 19 26.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconArrowRightWhiteCircleBlue);
export default __webpack_public_path__ + "static/media/Nav_Icon_ArrowRightWhite_CircleBlue.fc1cf48f26ecd38539327248d0bf5e0a.svg";
export { ForwardRef as ReactComponent };